module.exports = __webpack_public_path__ + "img/C12-scotland.93a643a3.png";